<script setup lang="ts">
interface Serie {
  name: string;
  data: number[];
}

interface Props {
  title: string;
  height?: number;
  series: Serie[];
  categories: string[];
  valueFormater?: (value: number) => string;
}

const props = defineProps<Props>();

const chartAttrs: any = {
  series: props.series,
  options: {
    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    markers: {
      size: 6,
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: props.categories,
    },
  },
};

if (props.valueFormater) {
  chartAttrs.options.yaxis = {
    labels: {
      formatter: (value: number) => {
        if (typeof props.valueFormater === 'function')
          return props.valueFormater(value);
      },
    },
  };
}
</script>
<template>
  <a-card :title="props.title">
    <a-empty v-if="props.categories.length === 0" />
    <apexchart
      v-else
      type="line"
      :height="props.height"
      v-bind="chartAttrs"
    ></apexchart>
  </a-card>
</template>
